<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="news">
        <!--Новая закупка-->
        <v-container class="app-container">
            <v-row class="d-flex justify-center">
                <v-col
                        sm="8"
                        md="8"
                        lg="8"

                >
                    <h1 class="justify-center pa-0">{{ metaData.header }}</h1>
                    <!--Карточка новой закупки-->
                    <template>
                        <v-stepper v-model="e1" class="background-transparent">
                            <div class="d-flex justify-center">
                                <!--Слайдер новой закупки-->
                                <v-stepper-header>
                                    <v-stepper-step
                                            :complete="e1 > 1" step="1"
                                            color="orange lighten-2 "
                                    >
                                        <div>
                                            {{$t('mainData')}}
                                        </div>
                                    </v-stepper-step>

                                    <v-divider></v-divider>

                                    <v-stepper-step
                                            step="2"
                                            color="orange lighten-2 "
                                    >
                                        <div >
                                            {{$t('paymentAndDelivery')}}
                                        </div>
                                    </v-stepper-step>
                                </v-stepper-header>
                            </div>

                            <!--Окно карточки новой закупки-->
                            <v-stepper-items>
                                <v-stepper-content step="1">
                                    <!--Основные данные-->
                                    <v-card
                                            class="mb-10 border-transparent min-height-card"
                                            outlined
                                    >
                                        <v-list
                                                dense
                                                flat
                                                class="px-8"
                                        >
                                            <!--Основные данные-->
                                            <v-row>
                                                <v-col
                                                        sm="6"
                                                >
                                                    <v-list-item-group>

                                                        <v-list-item
                                                                class="pa-0"
                                                                v-for="info in mainInfo"
                                                                :key="info.id"
                                                        >
                                                            <v-list-item-icon class="mr-3">
                                                                <v-icon color="orange lighten-2">{{info.icon}}</v-icon>
                                                            </v-list-item-icon>
                                                            <v-list-item-content class="caption">{{info.text}}</v-list-item-content>
                                                        </v-list-item>

                                                    </v-list-item-group>
                                                </v-col>
                                                <v-col
                                                        sm="6"
                                                >
                                                    <v-list-item-group>
                                                        <v-list-item
                                                                class="pa-0"
                                                                v-for="info in mainInfo2"
                                                                :key="info.id"
                                                        >
                                                            <v-list-item-icon class="mr-3">
                                                                <v-icon color="orange lighten-2">{{info.icon}}</v-icon>
                                                            </v-list-item-icon>
                                                            <v-list-item-content class="caption">{{info.text}}</v-list-item-content>
                                                        </v-list-item>

                                                    </v-list-item-group>
                                                </v-col>
                                            </v-row>
                                        </v-list>

                                        <v-divider></v-divider>
                                        <!--Данные покупателя-->
                                        <v-row class="px-8">
                                            <v-col
                                                    class="mobile-col"
                                                    sm="6"
                                                    md="6"
                                                    lg="6"
                                            >
                                                <div
                                                        v-for="text in textArea"
                                                        :key="text.id"
                                                >
                                                    <v-text-field
                                                            class="width-300"
                                                            :label="text.text"
                                                            color="orange lighten-2"
                                                    ></v-text-field>
                                                </div>
                                            </v-col>
                                            <v-col
                                                    class="mobile-col"
                                                    sm="6"
                                                    md="6"
                                                    lg="6"
                                            >
                                                <div
                                                        v-for="text in textArea2"
                                                        :key="text.id"
                                                >
                                                    <v-text-field
                                                            class="width-300"
                                                            :label="text.text"
                                                            color="orange lighten-2"
                                                    ></v-text-field>
                                                </div>
                                            </v-col>
                                        </v-row>
                                        <!--Сообщение продавцу-->
                                        <v-textarea
                                                solo
                                                :label="$t('messagesToSeller')"
                                                auto-grow
                                                name="text-to-seller"
                                                class="px-8 border-transparent"
                                                color="orange lighten-2"
                                                outlined
                                        ></v-textarea>
                                    </v-card>
                                    <!--Кнопки Далее и Назад - Основные данные-->
                                    <div class="d-flex justify-space-between">
                                        <v-btn
                                                outlined
                                                dark
                                                class="caption text--main-yellow "
                                                justify="center"
                                                rounded
                                                width="130"
                                        >{{$t('back')}}</v-btn>

                                        <v-btn
                                                @click="e1 = 2"
                                                dark
                                                depressed
                                                class="caption orange lighten-2 "
                                                rounded
                                                width="130"
                                        >
                                            {{$t('next')}}
                                        </v-btn>
                                    </div>

                                </v-stepper-content>



                                <!--Оплата и доставка-->
                                <v-stepper-content step="2">
                                    <v-card
                                            class="mb-10 border-transparent min-height-card"
                                            outlined
                                    >
                                        <v-row
                                                class="px-8"
                                        >
                                            <!--Способы оплаты-->
                                            <v-col
                                                    sm="6"
                                                    md="6"
                                                    lg="6"
                                                    class="radio-btn px-5"
                                            >
                                                <div class="subtitle-1 font-weight-bold pa-3 pl-0">{{$t('paymentMethod')}}</div>
                                                <v-radio-group
                                                        column
                                                        v-model="payTo"
                                                        v-for="payment in paymentMethod"
                                                        :key="payment.id"
                                                >
                                                    <v-radio
                                                            :label="payment.method"
                                                            :value="payment.method"
                                                            color="orange lighten-2"
                                                            class="pa-0 ma-0"
                                                    ></v-radio>
                                                </v-radio-group>
                                            </v-col>
                                            <!--Доставка-->
                                            <v-col
                                                    sm="6"
                                                    md="6"
                                                    lg="6"
                                                    class="radio-btn px-5"
                                            >
                                                <div class="subtitle-1 font-weight-bold pa-3 pl-0">{{$t('delivery')}}</div>
                                                <!--Как можно скорее-->
                                                <v-radio-group
                                                        column
                                                        v-model="deliveryTo"
                                                        v-for="delivery in deliveryMethod"
                                                        :key="delivery.id"
                                                >
                                                    <v-radio
                                                            :label="delivery.method"
                                                            :value="delivery.method"
                                                            color="orange lighten-2"
                                                            class="pa-0 ma-0"
                                                    ></v-radio>
                                                    <!--Кнопка вызова календаря-->
                                                    <v-menu
                                                            ref="menu"
                                                            v-model="menu"
                                                            :close-on-content-click="false"
                                                            :return-value.sync="picker"
                                                            transition="scale-transition"
                                                            width="220"
                                                    >
                                                        <template v-slot:activator="{ on }">

                                                            <v-radio-group
                                                                    column
                                                                    v-model="deliveryTo"
                                                            >
                                                                <v-radio
                                                                        label="Выбрать дату"
                                                                        value="date"
                                                                        color="orange lighten-2"
                                                                        class="pa-0 ma-0"
                                                                        v-on="on"
                                                                ></v-radio>
                                                            </v-radio-group>

                                                        </template>
                                                        <v-date-picker
                                                                v-model="picker"
                                                                header-color="orange lighten-2"
                                                                color="orange lighten-2"
                                                                locale="ru"
                                                                width="298"
                                                        >
                                                            <v-spacer></v-spacer>
                                                            <v-btn text  color="orange lighten-2" @click="menu = false">Назад</v-btn>
                                                            <v-btn text  color="orange lighten-2" @click="$refs.menu.save(picker)">Выбрать</v-btn>
                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-radio-group>

                                            </v-col>
                                        </v-row>
                                        <v-divider></v-divider>
                                    </v-card>
                                    <!--Кнопки Подтвердить и Назад - Оплата и доставка-->
                                    <div class="d-flex justify-space-between">

                                        <v-btn
                                                @click="e1 = 1"
                                                outlined
                                                dark
                                                class="caption text--main-yellow "
                                                justify="center"
                                                rounded
                                                width="130"
                                        >{{$t('back')}}</v-btn>
                                        <!--Модальное окно подтвердить закупку-->
                                        <v-dialog v-model="dialog" persistent max-width="500">
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                        dark
                                                        depressed
                                                        class="caption orange lighten-2 "
                                                        rounded
                                                        width="130"
                                                        v-on="on"
                                                >{{$t('confirm')}}</v-btn>
                                            </template>
                                            <v-card>
                                                <v-card-title class="subtitle-1 font-weight-bold d-flex justify-center">{{$t('thankYouForYourPurchase')}}</v-card-title>
                                                <v-divider></v-divider>
                                                <v-card-actions class="pa-8">
                                                    <v-btn
                                                            dark
                                                            depressed
                                                            class="caption orange lighten-2 "
                                                            rounded
                                                            width="130"
                                                            @click="dialog = false"
                                                    >{{$t('toCatalog')}}</v-btn>
                                                    <v-spacer></v-spacer>
                                                    <v-btn
                                                            @click="dialog = false"
                                                            outlined
                                                            dark
                                                            class="caption text--main-yellow "
                                                            justify="center"
                                                            rounded
                                                            width="130"
                                                    >{{$t('myPurchases')}}</v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>

                                    </div>
                                </v-stepper-content>
                            </v-stepper-items>
                        </v-stepper>
                    </template>
                </v-col>
            </v-row>
        </v-container>

    </div>
</template>

<script>
    import './new-purchase.scss'

    export default {
        name: "NewPurchase",
        data() {
            return {
                metaUrl: '/orders/add',
                e1: 1,
                /*Основные данные*/
                mainInfo: [
                    {id:1 ,icon:'people_alt', text:'Продавец'},
                    {id:2 ,icon:'account_balance', text:'Компания'},
                    {id:3 ,icon:'location_on', text:'Одесская обл., Кислица, улица'},
                    {id:4 ,icon:'control_point', text:'Еще адрес'},
                ],
                mainInfo2: [
                    {id:1 ,icon:'email', text:'namesite@gmail.com'},
                    {id:2 ,icon:'settings_phone', text:'+38(093)342-32-12'},

                ],
                /*Данные покупателя*/
                textArea: [
                    {id:1, text:this.$t('nameSurname')},
                    {id:2, text:'E-mail'},
                    {id:3, text:this.$t('telephone')},
                ],
                textArea2: [
                    {id:1, text:this.$t('region')},
                    {id:2, text:this.$t('city')},
                    {id:3, text:this.$t('address')},
                ],
                /*Итого к оплате*/
                totalPrice:[
                    {price:'108', currency:'грн'},
                ],
                /*Способы оплаты*/
                paymentMethod: [
                    {id:1, method:'Наличными'},
                    {id:2, method:'Банковская карта '},
                    {id:3, method:'Безналом на юр. лицо'},
                    {id:4, method:'Банковский перевод для юр. лиц'},
                    {id:5, method:'Наличными для юр. лиц'},
                    {id:6, method:'Покупка в рассрочку'},
                    {id:7, method:'Наложенный платеж'},
                ],
                payTo: null,
                /*Способ доставки*/
                deliveryMethod: [
                    {id:1, method:'Как можно быстрее'},

                ],
                deliveryTo: null,
                /*Календарь*/
                picker: new Date().toISOString().substr(0, 10),
                menu: false,
                /*Модальное окно подтвердить закупку*/
                dialog: false,

            }
        },
        methods: {
            showDatepicker() {
                this.menu = !this.menu;
            }
        }
    }
</script>

<style scoped>

</style>